import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { GetConnectionsCount } from "src/services/organizations/queries/NetTypes";

import { useGetApp } from "../../AppSettings/Details/hook/useGetApp";
import Context from "../context";

export default function useDataChart() {
	const { product } = useContext(Context);

	const app = useGetApp();

	const { data } = useQuery<GetConnectionsCount>({
		queryKey: [app?.id, product ? `${product}Count` : "allCount"],
		initialData: { variation: { mtd: 0, ytd: 0, day: 0 }, current: [] }
	});

	const success = data.current
		.filter((i) => i.status === "READY")
		.reduce((acc, cur) => acc + cur.count, 0);
	const error = data.current
		.filter((i) => i.status === "ERRORED")
		.reduce((acc, cur) => acc + cur.count, 0);

	return {
		series: [success, error]
	};
}
